export default alert => {
  return alert.closedReason
    ? alert.status.code + " - " + alert.closedReason.description
    : alert.status.code;
};
